import { COOKIE_BROADBAND_ORDER } from '@/constants/cookies';
import { getBroadbandOrder } from '@/graphql/queries/broadband';
import lang from '@/lang/middleware/products/broadband';

export default async ({ $apolloQuery, app, $config, $cookies, redirect, $phone, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const code = $cookies.get(COOKIE_BROADBAND_ORDER);
  await $apolloQuery(getBroadbandOrder, { code }).then(order => {
    const subtitle = store.$i18n.t('thank-you.jumbotron.subtitle', { phone: $phone($config.phone) });
    const title = store.$i18n.t('thank-you.jumbotron.title', { name: order.customer.fname });
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('pageContent/setHead', { title: store.$i18n.t('thank-you.title') });
    store.commit('products/set', order.bundle);
    delete order.bundle;
    store.commit('order/set', order);
  }).catch(_ => redirect(app.localePath('/compare-tv-broadband-phone/')));
};
